export const gtagConfigs = {
  trackerId: 'UA-107291227-1',
};
